import React, { useState } from 'react';
import logo from '../logo.png';
import { changePassword } from '../api';

export default function Header({ name, clientCode, onLogout, onSwitchAccount }) {
  const [menuOpen,    setMenuOpen]    = useState(false);
  const [showPwModal, setShowPwModal] = useState(false);
  const [oldPw,       setOldPw]       = useState('');
  const [newPw,       setNewPw]       = useState('');
  const [confirmPw,   setConfirmPw]   = useState('');
  const [pwError,     setPwError]     = useState('');
  const [pwSuccess,   setPwSuccess]   = useState('');
  const [pwLoading,   setPwLoading]   = useState(false);

  const initials = name ? name.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase() : 'CL';

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPwError(''); setPwSuccess('');
    if (!oldPw || !newPw || !confirmPw) { setPwError('All fields are required'); return; }
    if (newPw !== confirmPw) { setPwError('New passwords do not match'); return; }
    if (newPw.length < 8) { setPwError('Password must be at least 8 characters'); return; }
    setPwLoading(true);
    try {
      await changePassword(oldPw, newPw);
      setPwSuccess('Password changed successfully!');
      setOldPw(''); setNewPw(''); setConfirmPw('');
      setTimeout(() => { setShowPwModal(false); setPwSuccess(''); }, 2000);
    } catch (err) {
      setPwError(err.response?.data?.detail || 'Failed to change password');
    } finally {
      setPwLoading(false);
    }
  };

  return (
    <>
      <div style={{
        background: '#6B1C2A', height: 56, display: 'flex',
        alignItems: 'center', justifyContent: 'space-between',
        padding: '0 20px', flexShrink: 0, position: 'relative', zIndex: 100,
      }}>
        {/* Left: Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <img src={logo} alt="Pashupati Capital" style={{ height: 42 }} />
          <div style={{ width: 1, height: 26, background: 'rgba(255,255,255,0.25)' }} />
          <span style={{ color: '#fff', fontSize: 15, fontWeight: 500, letterSpacing: '0.02em' }}>
            PCSPL Pledge+
          </span>
        </div>

        {/* Right: User menu */}
        <div style={{ position: 'relative' }}>
          <div
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              cursor: 'pointer', padding: '4px 8px', borderRadius: 6,
              background: menuOpen ? 'rgba(255,255,255,0.1)' : 'transparent',
            }}
          >
            <div style={{
              width: 32, height: 32, borderRadius: '50%',
              background: '#8B2535', display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#fff',
            }}>
              {initials}
            </div>
            <span style={{ color: '#fff', fontSize: 13 }}>{name || `Client ${clientCode}`}</span>
            <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 10 }}>▾</span>
          </div>

          {menuOpen && (
            <div style={{
              position: 'absolute', right: 0, top: 48, background: '#fff',
              borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              width: 200, overflow: 'hidden', border: '1px solid #f0e8e5',
            }}>
              <div style={{ padding: '10px 14px', borderBottom: '1px solid #f5f0ee' }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>{name}</div>
                <div style={{ fontSize: 11, color: '#888' }}>Client Code: {clientCode}</div>
              </div>
              <div
                onClick={() => { setMenuOpen(false); setShowPwModal(true); }}
                style={{
                  padding: '10px 14px', fontSize: 13, color: '#555',
                  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
                  borderBottom: '1px solid #f5f0ee',
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#fdf9f8'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                🔑 Change Password
              </div>
              {(() => {
                const accounts = JSON.parse(localStorage.getItem('linked_accounts') || '[]');
                return accounts.length > 1 ? (
                  <div
                    onClick={() => { setMenuOpen(false); onSwitchAccount && onSwitchAccount(); }}
                    style={{
                      padding: '10px 14px', fontSize: 13, color: '#555',
                      cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
                      borderBottom: '1px solid #f5f0ee',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#fdf9f8'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    🔄 Switch Account
                  </div>
                ) : null;
              })()}
              <div
                onClick={onLogout}
                style={{
                  padding: '10px 14px', fontSize: 13, color: '#c0392b',
                  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#fdf9f8'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                ↩ Logout
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Change Password Modal */}
      {showPwModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000,
        }}
          onClick={e => { if (e.target === e.currentTarget) setShowPwModal(false); }}
        >
          <div style={{
            background: '#fff', borderRadius: 12, padding: 32, width: 380,
            boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
          }}>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#333', marginBottom: 6 }}>
              Change Password
            </div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>
              Enter your current password and choose a new one.
            </div>

            {pwError && (
              <div style={{ background: '#fdf0f0', border: '1px solid #f5c6c6', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#c0392b', marginBottom: 16 }}>
                {pwError}
              </div>
            )}
            {pwSuccess && (
              <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#166534', marginBottom: 16 }}>
                {pwSuccess}
              </div>
            )}

            <form onSubmit={handleChangePassword}>
              {[
                ['Current Password', oldPw, setOldPw],
                ['New Password',     newPw, setNewPw],
                ['Confirm New Password', confirmPw, setConfirmPw],
              ].map(([label, val, setter]) => (
                <div key={label}>
                  <label style={{ fontSize: 12, color: '#555', fontWeight: 500, marginBottom: 6, display: 'block' }}>
                    {label}
                  </label>
                  <input
                    type="password"
                    value={val}
                    onChange={e => setter(e.target.value)}
                    style={{
                      width: '100%', padding: '10px 14px', border: '1px solid #e0d8d5',
                      borderRadius: 8, fontSize: 14, outline: 'none', marginBottom: 16,
                      color: '#333', background: '#fdfcfc', boxSizing: 'border-box',
                    }}
                    onFocus={e => e.target.style.borderColor = '#6B1C2A'}
                    onBlur={e => e.target.style.borderColor = '#e0d8d5'}
                  />
                </div>
              ))}

              <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                <button type="button" onClick={() => setShowPwModal(false)}
                  style={{ flex: 1, padding: 11, background: '#fff', color: '#666', border: '1px solid #e0d8d5', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>
                  Cancel
                </button>
                <button type="submit" disabled={pwLoading}
                  style={{ flex: 1, padding: 11, background: '#6B1C2A', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: pwLoading ? 'not-allowed' : 'pointer' }}>
                  {pwLoading ? 'Saving...' : 'Change Password'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}